// src/index.js
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import "./styles/app.css";
import ThemeContextProvider from "./context/ThemeContext";
import { aplicarMarca } from "./config/marca";
import "leaflet/dist/leaflet.css";

// Fuentes (ya en tu archivo)
import "@fontsource-variable/inter";
import "@fontsource-variable/roboto-flex";
import "@fontsource-variable/jetbrains-mono";
import "@fontsource-variable/plus-jakarta-sans";
import "@fontsource-variable/urbanist";
import "@fontsource-variable/outfit";
import "@fontsource-variable/source-sans-3";
import "@fontsource-variable/work-sans";
import "@fontsource-variable/dm-sans";
import "@fontsource-variable/open-sans";
import "@fontsource-variable/montserrat";
import "@fontsource-variable/nunito";
import "@fontsource-variable/ibm-plex-sans";
import "@fontsource-variable/noto-sans";
import "@fontsource-variable/noto-serif";
import "@fontsource-variable/playfair-display";
import "@fontsource-variable/lora";
import "@fontsource-variable/fira-code";

// Título, ícono y color de la pestaña según la marca de la empresa (REACT_APP_MARCA).
aplicarMarca();

// En un campo numérico con el foco, la rueda del mouse cambia el valor según su "step" (0.01 en los montos): al bajar por la página
// un 40 terminaba guardado como 39.97 sin que nadie lo note. Se quita el foco antes de que la rueda lo modifique; la página sigue desplazándose.
document.addEventListener("wheel", () => {
  const el = document.activeElement;
  if (el?.tagName === "INPUT" && el.type === "number") el.blur();
}, { passive: true });

ReactDOM.render(
  <ThemeContextProvider>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </ThemeContextProvider>,
  document.getElementById("root")
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
